import jwtDecode from 'jwt-decode';
import get from 'lodash.get';

export const isExpired = token => {
  try {
    const expiresAt = new Date(jwtDecode(token).exp * 1000);
    const now = new Date();
    return now >= expiresAt;
  } catch (e) {
    return true;
  }
};

/**
 * Add here a global error handler
 */
export const handleErrors = error => {
  console.error(error);
};

export const getSpotifyLoginURI = () => {
  const clientId = process.env.VUE_APP_SPOTIFY_CLIENT_ID;
  const redirectUri = process.env.VUE_APP_SPOTIFY_REDIRECT;
  const scope = process.env.VUE_APP_SPOTIFY_AUTH_SCOPE;
  return `https://accounts.spotify.com/authorize?client_id=${clientId}&response_type=code&redirect_uri=${redirectUri}&scope=${scope}`;
};

export const getSpotifyAuthorizationURI = () => {
  const clientId = process.env.VUE_APP_SPOTIFY_CLIENT_ID;
  const redirectUri = process.env.VUE_APP_SPOTIFY_AUTHORITATION_REDIRECT;
  const scope = process.env.VUE_APP_SPOTIFY_AUTH_SCOPE;
  return `https://accounts.spotify.com/authorize?client_id=${clientId}&response_type=code&redirect_uri=${redirectUri}&scope=${scope}`;
};

// set the refresh time 5 miniutes before the token expires
export const calculateRefreshTimeByExpirationsTime = expiresIn => {
  if (expiresIn > 60) {
    return (expiresIn - 60 * 5) * 1000;
  }
  return 60 * 5 * 1000;
};

export const shouldTrackBeUpdated = (tracks, track) => get(
  tracks.slice().find(t => t.track_id === track.track_id),
  'is_transferred',
  1,
) === 0;

export const getGuestUrl = () => process.env.VUE_APP_GUEST_URL;
